<template>
    <pg-page title="Private Gym - Abonnementen"
             :header="header"
             subtitle="Investeer in jezelf"
             id="abonnementen"
    >

        <main>
            <div class="row row-cols-1 row-cols-md-3 mb-3 justify-content-md-center text-center">
<!--                <div class="col">-->
<!--                    <select-block :type="1" :selected_type="type" @click.native="type = 1" @looptijd="looptijd = $event">-->
<!--                        <template v-slot:title>-->
<!--                            Pay as-you-go-->
<!--                        </template>-->
<!--                        <template v-slot:price>-->
<!--                            €9,99<small class="text-muted fw-light">/mnd</small>-->
<!--                        </template>-->
<!--                        <template v-slot:bullets>-->
<!--                            <li><i class="fa-solid fa-chevron-right me-4"></i> Onbeperkt vrij trainen</li>-->
<!--                            <li><i class="fa-solid fa-chevron-right me-4"></i> Gratis Private Gym tas</li>-->
<!--                            <li><i class="fa-solid fa-chevron-right me-4"></i> Eén maand bedenktijd</li>-->
<!--                            <li v-bind:class="{'text-muted': looptijd === 1}">-->
<!--                                <i class="fa-solid fa-chevron-right me-4" v-if="looptijd === 12"></i>-->
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
<!--                                Eerste maand €1-->
<!--                            </li>-->
<!--                            <li v-bind:class="{'text-muted': looptijd === 1}">-->
<!--                                <i class="fa-solid fa-chevron-right me-4" v-if="looptijd === 12"></i>-->
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
<!--                                Gratis techniektraining-->
<!--                            </li>-->
<!--                        </template>-->
<!--                    </select-block>-->
<!--                </div>-->
                <div class="col">
                    <select-block :type="1" :selected_type="type" @click.native="type = 1" @looptijd="looptijd = $event">
                        <template v-slot:title>
                            Onbeperkt
                        </template>
                        <template v-slot:price>
                            €62,99<small class="text-muted fw-light"></small>
                        </template>
                        <template v-slot:bullets>
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Onbeperkt vrij trainen</li>
                            <li>
                                <i class="fa-solid fa-chevron-right me-4"></i>
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
                                Gratis Private Gym tas
                            </li>
                            <li v-bind:class="{'text-muted': looptijd === 1}">
                                <i class="fa-solid fa-chevron-right me-4" v-if="looptijd === 12"></i>
                                <i class="fa-solid fa-xmark me-4" v-else></i>
                                Eerste maand €1
                            </li>
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Eén maand bedenktijd</li>
                            <li>
                                <i class="fa-solid fa-chevron-right me-4"></i>
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
                                Gratis techniektraining
                            </li>
                        </template>
                    </select-block>
                </div>
                <div class="col">
                    <select-block :type="2" :selected_type="type" @click.native="type = 2" @looptijd="looptijd = $event">
                        <template v-slot:title>
                            + Personal training
                        </template>
                        <template v-slot:price>
                            €104,99<small class="text-muted fw-light"></small>
                        </template>
                        <template v-slot:bullets>
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Onbeperkt vrij trainen</li>
                            <li>
                                <i class="fa-solid fa-chevron-right me-4"></i>
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
                                Gratis Private Gym tas
                            </li>
                            <li v-bind:class="{'text-muted': looptijd === 1}">
                                <i class="fa-solid fa-chevron-right me-4" v-if="looptijd === 12"></i>
                                <i class="fa-solid fa-xmark me-4" v-else></i>
                                Eerste maand €1
                            </li>
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Eén maand bedenktijd</li>
<!--                            <li v-bind:class="{'text-muted': looptijd === 1}">-->
<!--                                <i class="fa-solid fa-chevron-right me-4" v-if="looptijd === 12"></i>-->
<!--                                <i class="fa-solid fa-xmark me-4" v-else></i>-->
<!--                                Gratis techniektraining-->
<!--                            </li>-->
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Personal training*</li>
<!--                            <li><i class="fa-solid fa-chevron-right me-4"></i> Extra PT sessies mogelijk </li>-->
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Tussentijdse evaluaties</li>
                            <li><i class="fa-solid fa-chevron-right me-4"></i> Focus op doelen behalen</li>
                        </template>
                    </select-block>
                </div>
            </div>

            <div class="row row-cols-1 mb-3 justify-content-md-center text-center">
                <em class="text-muted">
<!--                    <small>-->
<!--                        * indien je stopt binnen de bedenktijd, is de techniektraining éénmalig €60-->
<!--                    </small><br/>-->
                    <small>
                        * per periode, vaker is mogelijk! Overleg even met de PTer. <!-- Indien je stopt binnen de bedenktijd, is de personal training éénmalig €60 -->
                    </small>
                </em>
            </div>


            <!--            <div class="row mb-3 text-left">-->
<!--                <div class="col-sm-12 mt-2">-->
<!--                    <div class="border border-success rounded w-100">-->
<!--                        <div class="row w-100 p-1 m-0 p-0">-->
<!--                            <div class="col-sm-6 p-1">-->
<!--                                <button class="btn btn-sm btn-success w-100">-->
<!--                                    <i class="fa-solid fa-check ms-2 me-4"></i>  Looptijd van 12 maanden-->
<!--                                </button>-->
<!--                            </div>-->
<!--                            <div class="col-sm-6 p-1">-->
<!--                                <button class="btn btn-sm btn-success w-100">-->
<!--                                    Looptijd van 1 maand-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


            <div class="row row-cols-1 row-cols-md-3 mb-3 text-left mt-4">
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Online coaching
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Kant-en-klare training schema's
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> 24/7 toegang
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Ad-hoc personal training
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Periodieke check-in
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Je eigen eiland
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Trainen in een rustige gym
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Buddy motivatie systeem
                    </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <div class="bg-success text-white rounded p-1">
                        <i class="fa-solid fa-check ms-2 me-4"></i> Privacy
                    </div>
                </div>
            </div>

            <!-- Looptijd -->

            <template v-if="false">
                <h2 class="display-6 text-center mb-4">Compare plans</h2>

                <div class="table-responsive">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th style="width: 34%;"></th>
                            <th style="width: 22%;">Free</th>
                            <th style="width: 22%;">Pro</th>
                            <th style="width: 22%;">Enterprise</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row" class="text-start">Public</th>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Private</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        </tbody>

                        <tbody>
                        <tr>
                            <th scope="row" class="text-start">Permissions</th>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Sharing</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Unlimited members</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Extra security</th>
                            <td></td>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <!-- FORM -->
            <div class="row justify-content-md-center">
                <div class="col">
                    <div class="card p-1 p-md-4 pt-2 mt-4">
                        <div class="card-body pb-1">

                            <div class="mb-3">
                                <h5 class="card-title">
                                    Jouw gegevens
                                </h5>
                                <small class="card-subtitle mb-2 text-muted" v-if="attach">
                                    Zelfde als bij je registratie
                                </small>
                            </div>

                            <div class="row" v-if="!attach">
                                <div class="col-md">
                                    <div class="form-floating mb-3">
                                        <input v-model="first_name" type="text" v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.first_name,
                                                    'is-valid': typeof errors.first_name === 'undefined' && wasValidated,
                                                }"
                                               id="firstName" placeholder="Voornaam" required>
                                        <label for="firstName">Voornaam <span class="text-muted">*</span></label>
                                        <div class="invalid-feedback">
                                            {{ errors.first_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-floating mb-3">
                                        <input v-model="last_name" type="text"  v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.last_name,
                                                    'is-valid': typeof errors.last_name === 'undefined' && wasValidated,
                                                }"
                                               id="lastName" placeholder="Achternaam" required>
                                        <label for="lastName">Achternaam <span class="text-muted">*</span></label>
                                        <div class="invalid-feedback">
                                            {{ errors.last_name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md">
                                    <div :class="'form-floating ' + (attach ? '' : 'mb-3')">
                                        <input v-model="email" type="email"
                                               v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.email,
                                                    'is-valid': typeof errors.email === 'undefined' && wasValidated,
                                                }"
                                               id="email" placeholder="Email"  name="email" >
                                        <label for="email" class="form-label">Email <span class="text-muted">*</span></label>
                                        <div class="invalid-feedback">
                                            {{ errors.email }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md mb-3" v-if="!attach">
                                    <div class="form-floating">
                                        <input v-model="phone_number" type="text"
                                               v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.phone_number,
                                                    'is-valid': typeof errors.phone_number === 'undefined' && wasValidated,
                                                }"
                                               id="telephone" placeholder="Telefoonnummer" name="phone_number" required="">
                                        <label for="email" class="form-label">Telefoon <span class="text-muted">*</span></label>
                                        <div class="invalid-feedback">
                                            {{ errors.phone_number }}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div v-if="!attach" class="input-group" v-bind:class="{
                                'is-invalid': errors.password,
                                'is-valid': typeof errors.password === 'undefined' && wasValidated,
                            }">
                                <div class="form-floating flex-grow-1">
                                    <input v-model="password" :type="show_password ? 'input' : 'password'"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.password,
                                                    'is-valid': typeof errors.password === 'undefined' && wasValidated,
                                                }"
                                           id="password" name="password" required placeholder="Wachtwoord">
                                    <label for="password" class="form-label">Wachtwoord <small><span class="text-muted">(8+ karakters)</span></small></label>
                                </div>
                                <span class="input-group-text clickable" @click="show_password = !show_password">
                                    <i class="fa-solid fa-eye" v-if="show_password"></i>
                                    <i class="fa-sharp fa-solid fa-eye-slash" v-else></i>
                                </span>
                                <div class="invalid-feedback">
                                    {{ errors.password }}
                                </div>
                            </div>


                            <div :class="'m-1 mt-3 form-check ' + (!approve_legal && submitted ? ' text-danger fw-bold' : '')">
                                <input class="form-check-input" v-model="approve_legal" type="checkbox" value="" id="algemene-voorwaarden">
                                <label class="form-check-label" for="algemene-voorwaarden">
                                    <em>
                                        Ik ben akkoord met de <a href="/legal/algemene-voorwaarden">Algemene voorwaarden</a> en <a href="/legal/privacy-policy">Privacy policy</a>
                                    </em>
                                </label>
                            </div>

                            <div :class="'m-1 mt-3 form-check ' + (!approve_subscription && submitted ? ' text-danger fw-bold' : '')">
                                <input class="form-check-input" v-model="approve_subscription" type="checkbox" id="abonnement-check">
                                <label class="form-check-label" for="abonnement-check">
                                    <em v-if="looptijd === 1">
                                        Ik ben akkoord met een abonnement van €{{ prijs }} / 4 weken, maandelijks opzegbaar met een looptijd van minimaal één maand. Eén keer per 4 weken afgeschreven per automatische incasso. Dit kan ook 1x per maand op een vaste datum.
                                    </em>
                                    <em v-else>
                                        Ik ben akkoord met de eerste maand voor €1, en één maand bedenktijd. Daarna wordt je inschrijving automatisch een abonnement van €{{ (prijs) }} / 4 weken,  met een looptijd van minimaal {{ looptijd }} maand(en), 1x per 4 weken  afgeschreven per automatische incasso. Dit kan ook 1x per maand op een vaste datum.
                                    </em>
                                </label>
                            </div>

                            <div class="alert alert-info mb-0 mt-3 text-center" role="alert" v-if="looptijd === 1">
                                <i class="fa-solid fa-circle-info"></i> Nadat je op "Inschrijven" klikt betaal je eenmalig €{{ prijs }} voor de eerste maand <em>en</em> geef je daarmee automatisch toestemming voor de automatische incasso
                            </div>

                            <div class="alert alert-info mb-0 mt-3 text-center" role="alert" v-else>
                                <i class="fa-solid fa-circle-info"></i> Nadat je op "Inschrijven" klikt betaal je eenmalig €0.99 voor de eerste maand <em>en</em> als toestemming voor de automatische incasso
                            </div>



                            <div class="alert alert-danger mb-0 mt-3 text-center" role="alert" v-if="Object.keys(errors).length === 0 && hadError">
                                <i class="fa-solid fa-exclamation-circle"></i> Er is iets mis gegaan aan de server kant. Bel of mail even voor assistentie.
                            </div>


                            <div class="btn-group d-flex mt-3" role="group" @click="changeMind()" v-if="looptijd === 1">
                                <button type="button" class="btn btn-success disabled" style="opacity: 1; width:100px;">
<!--                                    <i class="fa-solid fa-badge-check me-3 ms-3"></i>-->
<!--                                    <img src="/fonts/icons/fa/badge-check-white.svg" alt="" style="width: 50%;">-->
                                    <img src="/fonts/icons/fa/percent-white.svg" alt="" style="width: 50%;">
<!--                                    <i class="fa-solid fa-percent"></i>-->
                                </button>
                                <button class="btn btn-outline-success w-100">
                                    Ik betaal toch liever 25% minder en kies voor een looptijd van 12 maanden en ook nog eens de eerste maand helemaal gratis!
                                </button>
                            </div>


                            <div class="btn-group d-flex mt-3" role="group">
                                <button class="btn btn-primary w-100 btn-lg" @click="send">
                                    <i class="fa-solid fa-chevron-right me-3"></i> Inschrijven
                                </button>
                                <button type="button" class="btn btn-outline-dark disabled" style="opacity: 1;">
                                    <img src="/images/ideal-logo.svg" alt="" style="width: 39px;">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Nog twijfels? Plan dan een rondleiding en kom kijken of Private Gym iets voor jou is
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="false" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import Modal from "../Components/Modal";
import SignUpButton from "../Components/Prijzen/SignUpButton";
import SelectBlock from "../Components/Abonnementen/SelectBlock";
import ActionButtons from "../Components/Index/ActionButtons";
export default {
    components: {
        ActionButtons,
        SelectBlock,
        PgPage
    },

    props:{
        attach: { default: false },
    },

    mixins: [],

    data: function () {
        return {
            loading: false,
            submitted: false,
            errors: {},
            hadError: false,
            wasValidated: false,

            type: 1, // 1 is Onbeperkt, 2 is Personal training
            looptijd: 12,
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            password: '',

            show_password: false,
            approve_legal: false,
            approve_subscription: false,

        };
    },

    computed: {
        header() {
          return this.attach ? 'Abonnement koppelen' : 'Abonnementen';
        },
        prijs() {
            let prijs = this.type === 1 ? 62.99 : 104.99;
            if(this.looptijd === 1) {
                prijs += 19;
            }
            return Math.round(prijs * 100) / 100;
        },
        prijs12() {
            let prijs = this.type === 1 ? 62.99 : 104.99;
            return Math.round(prijs * 100) / 100;
        },
        personalTraining() {
            return this.type === 1 ? 'eenmalig' : 1;
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        changeMind() {
            this.looptijd = 12;
        },
        send() {
            this.submitted = true;
            this.hadError = false;
            if(!this.approve_legal) {
                return;
            }
            if(!this.approve_subscription) {
                return;
            }

            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;

            window.axios.post(process.env.MIX_API_URL + '/api/v1/subscription', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone_number: this.phone_number,
                password: this.password,
                password_confirmation: this.password,

                looptijd: parseInt(this.looptijd),
                personal_training: this.personalTraining,
                stok_achter_de_deur: 0,
            })
                .then(function (response) {
                    vm.wasValidated = true;
                    let paymentLink = response.data.data;
                    window.location.href = paymentLink;
                })
                .catch(function (error) {
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                    vm.hadError = true;
                });
        },
        sendAttach() {
            this.submitted = true;
            if(!this.legal) {
                return;
            }

            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;

            window.axios.post(process.env.MIX_API_URL + '/api/v1/subscription/attach', {
                email: this.email,
                looptijd: this.looptijd,
                personal_training: this.personalTraining,
                stok_achter_de_deur: 0,
            })
                .then(function (response) {
                    vm.wasValidated = true;
                    let paymentLink = response.data.data;
                    window.location.href = paymentLink;
                })
                .catch(function (error) {
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                });
        },
    },

    watch: {
        //
    }
};
</script>

<style lang="scss" scoped>

</style>
